import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css'; // Import the CSS file
import axios from 'axios'; // Import Axios for API calls

const CenterBannerList = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userData, setUserData] = useState([]); // State for user data
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of users per page
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/get-allcenter-banners?page=${currentPage}&limit=${limit}&search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        setUserData(response.data.banners);
        setTotalPages(response.data.totalPages);
      } else {
        console.log("Error getting List");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
};

  
  const handleEdit = (id) => {
    console.log(id,"id")
    history.push(`/editcenterbanner/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://brand.aasmo.in/api/admin/deletecenter-banner/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        fetchUserData(); // Refresh data after deletion
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false); // Close modal after deletion
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };



  // Fetch user data from API
  useEffect(() => {


    fetchUserData();
  }, [currentPage, limit, searchQuery]); // Dependencies
  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Center Banner</h2>
        </div>
        <div className="body">
          {/* Search Input */}
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by Banner Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>

          <div className="table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Name</th>
                <th>Pincode</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>
                    {user.image && (
                      <img 
                        src={user.image} 
                        alt="image" 
                        style={{ width: "50px", height: "50px", borderRadius: "50%" }} 
                      />
                    )}
                  </td>
                  <td>{user.bannerName}</td>
                  <td>{user.pincode}</td>
                  <td>{formatDate(user.createdAt)}</td>
                  <td>
                  <i className="icon-pencil" onClick={(e) => handleEdit(user._id)}></i>

                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user._id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>

          {/* Pagination Controls */}
          <div className="body">
            <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </NavLink>
                </li>
                {[...Array(totalPages).keys()].map(page => (
                  <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                    <NavLink
                      to="#"
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </NavLink>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedUserId)}
      />
    </div>
  );
};

export default CenterBannerList;
